<template>
  <div>
    <vue-headful title="Inspection Address" />
    <LocationForm
      ref="location"
      :model="locationComponentData"
      @submit="submitForm"
      @save="save"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import LocationForm from '@/components/forms/LocationForm.vue';
import RouteNameConstants from '@/router/constants/route-names';
import StepUtilities from '@/router/utilities/step-utilities';

export default {
  components: {
    LocationForm,
  },
  inject: ['$validator'],
  computed: {
    ...mapState('Appointment', [
      'locationComponentData',
    ]),
  },
  methods: {
    /**
     * Retrieve Geocode Geometry for an Address during submission.
     * Address is assumed valid from LocationForm
     *
     * @doc: https://developers.google.com/maps/documentation/javascript/examples/geocoding-simple#maps_geocoding_simple-javascript
     * @param {locationComponentData} data
     * @returns {Promise<lat|lng>}
     */
    geocodeAddress(data) {
      return new Promise(resolve => {
        if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
          resolve(null);
        } else {
          const address = `${data.address1}${data.address2 ? ` ${data.address2}` : ''}, ${data.city}, ${data.state} ${data.postalCode}`;
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results.length > 0) {
              resolve({
                latitude: results[0].geometry.location.lat(),
                longitude: results[0].geometry.location.lng(),
              });
            } else {
              resolve(null);
            }
          });
        }
      });
    },
    async save(data) {
      const payload = { ...data };
      const geocode = await this.geocodeAddress(data);
      payload.latitude = geocode ? geocode.latitude : 0;
      payload.longitude = geocode ? geocode.longitude : 0;
      return this.$store.dispatch('Appointment/setLocation', payload);
    },
    async submitForm(data) {
      await this.save(data);
      StepUtilities.goToNextStep(this.$route, this.$router);
    },
  },
  mounted() {
    this.$store.commit('setStepIndex',
      StepUtilities.getStepIndexByRouteName(RouteNameConstants.AppointmentProperty));
  },
};
</script>
